import api from 'api';

export const loadApplications = api('GET /api/applications/grid');

export const loadApplication = api('GET /api/applications/:id');

export const updateApplication = api('PUT /api/applications/:id');

export const activateApplication = api('PUT /api/applications/:id/activate');
export const inactivateApplication = api(
  'PUT /api/applications/:id/inactivate'
);
